import { OverlayRef } from '@angular/cdk/overlay';
import { INotificationToastConfig } from './toast-config';

export class NotificationToastRef {
  constructor(
    private overlayRef: OverlayRef,
    public config: INotificationToastConfig,
  ) {}

  close(): void {
    // Wait for the CSS animation to complete before disposing the overlay
    // Toast CSS animation duration is 300ms, so wait a bit longer
    setTimeout(() => {
      this.overlayRef.dispose();
    }, 320);
  }
}
